import { render, staticRenderFns } from "./UserImportSummaryConfigurationModal.vue?vue&type=template&id=2961b909&"
import script from "./UserImportSummaryConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./UserImportSummaryConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports